import React from 'react';
import PropTypes from 'prop-types';

import {TextField as MUTextField} from '@mui/material';

const currencyRegex = /^\d*(\.\d{0,2})?$/;
const CurrencyField = (props) => {
  const [isInvalid, setIsInvalid] = React.useState(false);

  const {
    value = '',
  } = {...props};

  const {
    validation = {regex: currencyRegex},
    onChange,
    onBlur = () => {},
    ...textFieldProps
  } = {...props};

  const onUpdate = (e) => {
    const val = e.target.value;
    if (( val === '') || currencyRegex.test(val)) {
      onChange(e.target.value);
      if (validation && validation.regex && validation.update) {
        const re = new RegExp(validation.regex);
        const isValid = re.test(e.target.value);
        validation.update(isValid);
        setIsInvalid(!isValid);
      }
    }
  };

  const validate = () => {
    if (validation && validation.regex && validation.update) {
      const re = new RegExp(validation.regex);
      const isValid = re.test(value);
      validation.update(isValid);
      setIsInvalid(!isValid);
    }
  };


  const inputProps = {
    style: {
      height: 32,
    },
    ...(textFieldProps.InputProps || {}),
  };

  return (
    <MUTextField
      variant={'outlined'}
      {...textFieldProps}
      InputProps={inputProps}
      onChange={onUpdate}
      onBlur={() => validate() | onBlur()}
      error={isInvalid}
    />
  );
};

CurrencyField.propTypes = {
  value: PropTypes.any,
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard']),
  onChange: PropTypes.func.isRequired,
  validation: PropTypes.object,
  icon: PropTypes.object,
};

export default CurrencyField;
